import type { CSSProperties } from "react";
import { Select } from "antd";

export interface MetricSelectProps {
  /** Grouped options from `useReduxMetricDropdown`. */
  metricDropdown: any[];
  value: string | null | undefined;
  onChange: (value: string) => void;
  style?: CSSProperties;
}

/**
 * Searchable metric `<Select>` over the grouped metric-dropdown options.
 * Extracted from the identical copies in the metric-dropdown step and the
 * radar / table_2d / table-column configurator rows.
 */
export function MetricSelect({ metricDropdown, value, onChange, style = { width: "100%" } }: MetricSelectProps) {
  return (
    <Select
      options={metricDropdown}
      placeholder="Choose Metric"
      style={style}
      size="small"
      onChange={(v: string) => onChange(v)}
      value={value ?? undefined}
      showSearch
      fieldNames={{ label: "displayLabel", value: "value" }}
      filterOption={(input: string, option: any) =>
        option?.displayLabel?.toLowerCase()?.includes(input.toLowerCase()) || false
      }
    />
  );
}
